import { Form } from 'antd';
import { RevxRadio } from 'components';
import { RevxRadioProps } from 'components/RevxRadio';
import { JobOptionSvc } from 'domains/jobconfigDomain';
import { uniqBy } from 'lodash-es';
import { useOneofId } from '../hook/useOneofId';
import { IOneofProps } from '../OneOfSvcs';

interface Iprops extends IOneofProps {
  svc?: JobOptionSvc;
}

const CommonOneofSvcSpec = (props: Iprops) => {
  const { svc, svcDisabled, disabled } = props;

  const id = useOneofId(props);

  const typeRadioProps = (label: string): RevxRadioProps => {
    return {
      disabled: svcDisabled || disabled,
      outSideRevxLayoutProps: {
        align: 'top',
        justify: 'left',
        wrap: 'wrap',
        className: 'jobconfig-jobOption-content-outSideOption-default',
        style: {
          paddingBottom: 0,
          marginTop: 10,
        },
      },
      inSideRevxLayoutProps: {
        align: 'top',
        justify: 'left',
        className: 'jobconfig-jobOption-content-inSideOption-default',
        style: {
          marginRight: 31,
        },
      },
      options:
        uniqBy(
          svc?.specs.map((spec) => {
            return {
              value:
                spec.parameters.find((param) => param.label === label)
                  ?.parameter || '',
              children: (
                <span>
                  {
                    spec.parameters.find((param) => param.label === label)
                      ?.parameter
                  }
                </span>
              ),
            };
          }),
          'value'
        ) || [],
    };
  };

  return (
    <>
      {Boolean(svc) && (
        <div>
          {svc?.parameterLabels?.map((label, idx) => (
            <div
              key={`${id}-spec-${label}`}
              style={{ margin: `${idx !== 0 ? 10 : 0}px 0px 0` }}
            >
              <div
                className="jobconfig-jobOption-content-label"
                style={{ margin: '0px 0 0px 0' }}
              >
                {label}
              </div>
              <Form.Item name={[id, 'spec', label]} noStyle>
                <RevxRadio {...typeRadioProps(label)} />
              </Form.Item>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default CommonOneofSvcSpec;
